import axiosInstance from "@/api/axios-instance";

export type EmailStatus =
  | "QUEUED"
  | "SENT"
  | "DELIVERED"
  | "DELIVERY_DELAYED"
  | "OPENED"
  | "CLICKED"
  | "BOUNCED"
  | "DELIVERY_FAILED"
  | "COMPLAINED"
  | "CANCELED"
  | "UNKNOWN";

export interface EmailRecord {
  id: string;
  recipient_email: string | null;
  subject: string | null;
  email_status: EmailStatus;
  provider: "RESEND";
  provider_email_id: string;
  provider_event_id: string | null;
  template_id: string | null;
  invoice_id: string | null;
  invoice_number: string | null;
  user_id: string | null;
  lead_id: string | null;
  failure_reason: string | null;
  bounce_reason: string | null;
  created_at: string;
  updated_at: string;
}

export interface GetEmailsParams {
  page: number;
  search?: string;
  filter?: string;
}

export interface GetEmailsResponse {
  emails: EmailRecord[];
  totalCount: number;
  page: number;
  lastPage: number;
}

export const emailService = {
  async getEmails(params: GetEmailsParams): Promise<GetEmailsResponse> {
    const { data } = await axiosInstance.get("/emails", { params });
    return data;
  },

  async retryEmail(emailId: string) {
    const { data } = await axiosInstance.post(`/emails/${emailId}/retry`);
    return data;
  },
};
